import Glide, { Controls, Breakpoints, Swipe, Keyboard, Autoplay } from 'glide-library';
import { Breakpoints as BreakpointsEnum } from './breakpoints.js';

/**
 * Returns the default modules used by the carousel. (This is an anonymous object so changing it won't affect
 * other instances)
 * @returns {{Breakpoints: ((function(*, *, *): {match: function(Object): (*)})|*), Swipe: ((function(*, *, *): {bindSwipeStart: function(): Void, move: function(Object): (boolean|undefined), start: function(Object): Void, unbindSwipeStart: function(): Void, threshold: function(*): Number, mount: function(): Void, touches: function(Object): (Object), enable: function(): self, disable: function(): self, unbindSwipeEnd: function(): Void, bindSwipeMove: function(): Void, end: function(Object): Void, bindSwipeEnd: function(): Void, unbindSwipeMove: function(): Void})|*), Keyboard: ((function(*, *, *): {bind: function(): Void, unbind: function(): Void, press: function(Object): Void, mount: function(): Void})|*), Controls: ((function(*, *, *): {removeClass: function(HTMLElement): Void, mount: function(): Void, resetArrowState: function(): void, removeBindings: function(): Void, click: function(Object): void, setArrowState: function(): void, removeActive: function(): Void, setActive: function(): Void, bind: function(HTMLCollection): Void, disableArrow: function(): void, unbind: function(HTMLCollection): Void, addBindings: function(): Void, addClass: function(HTMLElement): Void})|*)}}
 */
export const getDefaultModules = () => {
    return {
        Controls: Controls,
        Breakpoints: Breakpoints,
        Swipe: Swipe,
        Keyboard: Keyboard
    }
};

/**
 * Default peek values for different screen sizes.
 * @type {{small: number, big: number, medium: number}}
 */
export function getPeek () {
    return {
        big: 150,
        medium: 100,
        small: 50
    };
}

/**
 * Default perView values for different screen sizes.
 * @type {{small: number, big: number, medium: number}}
 */
export function getPerView ()  {
    return {
        big: 4,
        medium: 2,
        small: 1
    };
}

/**
 * Default carousel options for carousels that show multiple items per view.
 * This is an anonymous object so changing it won't affect other instances.
 * @returns {{perView: number, animationDuration: number, keyboard: boolean, bound: boolean, breakpoints: {[p: number]: {perView: number, peek: {before: number, after: number}}|{perView: number, peek: {before: number, after: number}}}, type: string, peek: number}}
 */
export function getDefaultOptions() {
    return {
        type: 'slider',
        perView: getPerView().big,
        peek: 0,
        bound: true,
        keyboard: true,
        animationDuration: 400,
        breakpoints: {
            [BreakpointsEnum.getBreakpoint('xl')]: {
                perView: getPerView().medium,
                peek: { before: getPeek().medium, after: getPeek().medium }
            },
            [BreakpointsEnum.getBreakpoint('md')]: {
                perView: getPerView().small,
                peek: { before: getPeek().small, after: getPeek().small }
            }
        }
    };
}

/**
 * Removes extra bullets that would make the slider show empty spaces at the end.
 * @param bullets - All bullet elements. (element.querySelectorAll('.carousel-indicator'))
 * @param slides - All slide elements. (element.querySelectorAll('.glide__slide'))
 * @param glide - The Glide instance.
 */
export function removeExtraButtons(bullets, slides, glide) {
    if (glide.type === 'slider' && slides.length > glide.settings.perView) {
        // Hide bullets if they just make the slider show empty spaces at the end.
        bullets.forEach(bullet => bullet.classList.remove('d-none'));
        [ ...bullets ].slice(slides.length - (glide.settings.perView - 1)).forEach(bullet => {
            bullet.classList.add('d-none');
        });
    }
}



export {Glide, Controls, Breakpoints, Swipe, Keyboard, Autoplay}